import _defineProperty from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
var __jsx = React.createElement;
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useState } from "react";
import { size, get, values, every, isEmpty } from "lodash";
import { faCircleCheck, faCircleXmark } from "@fortawesome/pro-regular-svg-icons";
import { isNonDicomFile } from "../../../utils";
import AwesomeIcon from "../../AwesomeIcon";
import { customRegexValidation, startCharCheckValidation, validateFields } from "../../../utils/regexValidation";
import constants from "../../../utils/constants";
import { t } from "i18next";
import DesktopFilesList from "./DesktopFilesList";
import MobileFilesList from "./MobileFilesList";
var defaultData = {
  patientName: "",
  patientId: "",
  patientAge: "",
  patientGender: ""
};
var FilesList = function FilesList(props) {
  var formattedSelectedFiles = props.formattedSelectedFiles,
    toggleIsSelected = props.toggleIsSelected,
    setSelectedFiles = props.setSelectedFiles,
    selectedFiles = props.selectedFiles,
    onSelectAll = props.onSelectAll,
    isSelectAll = props.isSelectAll,
    setEditRowId = props.setEditRowId,
    editRowId = props.editRowId,
    hasCurrentPatient = props.hasCurrentPatient;
  var _useState = useState(defaultData),
    patientDetail = _useState[0],
    setPatientDetail = _useState[1];
  var _useState2 = useState(false),
    isEditModalOpen = _useState2[0],
    setIsEditModalOpen = _useState2[1];
  var _useState3 = useState(defaultData),
    error = _useState3[0],
    setError = _useState3[1];
  if (!size(selectedFiles)) {
    return null;
  }
  var invalidFileError = function invalidFileError(fileObject) {
    var res = fileObject.filter(function (item) {
      return !item.isValidated;
    });
    if (res.length > 0) {
      return /*#__PURE__*/React.createElement("div", {
        className: "flex items-center justify-start space-x-1 whitespace-break-spaces"
      }, /*#__PURE__*/React.createElement(AwesomeIcon, {
        name: faCircleXmark,
        className: "text-red-600 sm:w-5"
      }), /*#__PURE__*/React.createElement("span", {
        className: "pl-2 text-red-600 whitespace-nowrap"
      }, get(res, ["0", "inValidMessage"], "") || t("invalid_scan")));
    } else {
      return /*#__PURE__*/React.createElement("div", {
        className: "flex items-center justify-start space-x-1 whitespace-break-spaces"
      }, /*#__PURE__*/React.createElement(AwesomeIcon, {
        name: faCircleCheck,
        className: "text-green-600 sm:w-5"
      }), /*#__PURE__*/React.createElement("span", {
        className: "pl-2 sm:text-green-600 whitespace-nowrap"
      }, t("valid_scan")));
    }
  };
  var unSelect = function unSelect(e, fileObject) {
    e.preventDefault();
    var isAllValidated = every(fileObject, ["isValidated", true]);
    if (!isAllValidated) {
      return;
    }
    fileObject.map(function (fileObj) {
      var fileKey = fileObj.fileKey;
      if (!!fileKey) {
        toggleIsSelected(fileKey);
      }
    });
  };
  var setMetaData = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(fileObj, hasError) {
      var _get;
      var _isNonDicomFile;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _isNonDicomFile = isNonDicomFile((_get = get(fileObj, ["file", "type"])) !== null && _get !== void 0 ? _get : "");
            return _context.a(2, new Promise(function (resolve) {
              var _fileObj$metaData;
              var hasEdit = (fileObj === null || fileObj === void 0 || (_fileObj$metaData = fileObj.metaData) === null || _fileObj$metaData === void 0 ? void 0 : _fileObj$metaData.SeriesInstanceUID) === editRowId;
              if (hasEdit) {
                var res = _objectSpread(_objectSpread({}, fileObj), {}, {
                  metaData: _objectSpread(_objectSpread({}, fileObj.metaData), {}, {
                    PatientAge: patientDetail.patientAge,
                    PatientName: patientDetail.patientName,
                    PatientGender: patientDetail.patientGender,
                    PatientID: patientDetail.patientId
                  })
                });
                if (!_isNonDicomFile) {
                  res.anonymize_dicom_metadata = true;
                }
                var inValidFilters = constants.REQUIRED_DICOM_METADATA.filter(function (field) {
                  return isEmpty(get(res, ["metaData", field], ""));
                });
                var isValid = isEmpty(inValidFilters);
                if (!isValid) {
                  res.inValidMessage = "".concat(t("missing_metadata"), ": ").concat(inValidFilters.join(", "));
                } else if (!hasError) {
                  res.inValidMessage = "";
                  res.isSelected = true;
                  res.isValidated = true;
                }
                return resolve(res);
              } else {
                return resolve(fileObj);
              }
            }));
        }
      }, _callee);
    }));
    return function setMetaData(_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
  var resetDetails = function resetDetails() {
    setIsEditModalOpen(false);
    setEditRowId("");
    setPatientDetail(defaultData);
    setError(defaultData);
  };
  var onEditData = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
      var hasError, filesArray;
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.n) {
          case 0:
            hasError = Object.values(error).filter(function (err) {
              return err.length > 0;
            }).length > 0;
            if (!hasError) {
              filesArray = values(selectedFiles).map(/*#__PURE__*/function () {
                var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(fileObj) {
                  return _regenerator().w(function (_context2) {
                    while (1) switch (_context2.n) {
                      case 0:
                        _context2.n = 1;
                        return setMetaData(fileObj, hasError);
                      case 1:
                        return _context2.a(2, _context2.v);
                    }
                  }, _callee2);
                }));
                return function (_x3) {
                  return _ref3.apply(this, arguments);
                };
              }());
              Promise.all(filesArray).then(function (response) {
                var fin_obj = {};
                response.forEach(function (item) {
                  if (!!item.fileKey) {
                    fin_obj[item.fileKey] = item;
                  }
                });
                setSelectedFiles(fin_obj);
                resetDetails();
              });
              setIsEditModalOpen(false);
            }
          case 1:
            return _context3.a(2);
        }
      }, _callee3);
    }));
    return function onEditData() {
      return _ref2.apply(this, arguments);
    };
  }();
  var onChangeRowData = function onChangeRowData(_value, _name) {
    var details = patientDetail;
    var errorDetails = error;
    var validation = validateFields([{
      fn: customRegexValidation,
      value: _value,
      err: " ".concat(t("add_patient_name_special_char_validation"), ",")
    }, {
      fn: startCharCheckValidation,
      value: _value,
      err: " ".concat(t("add_patient_name_start_validation"), ",")
    }]);
    if (_value && !validation) {
      details[_name] = _value;
      errorDetails[_name] = "";
    } else if (validation) {
      errorDetails[_name] = t("invalid_input");
    } else {
      errorDetails[_name] = t("required_key");
    }
    setPatientDetail(details);
    setError(errorDetails);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "w-full sm:px-4"
  }, /*#__PURE__*/React.createElement(DesktopFilesList, {
    isSelectAll: isSelectAll,
    onSelectAll: onSelectAll,
    hasCurrentPatient: hasCurrentPatient,
    unSelect: unSelect,
    formattedSelectedFiles: formattedSelectedFiles,
    onChangeRowData: onChangeRowData,
    editRowId: editRowId,
    setEditRowId: setEditRowId,
    error: error,
    invalidFileError: invalidFileError,
    onEditData: onEditData,
    resetDetails: resetDetails,
    setPatientDetail: setPatientDetail
  }), /*#__PURE__*/React.createElement(MobileFilesList, {
    onChangeRowData: onChangeRowData,
    invalidFileError: invalidFileError,
    onEditData: onEditData,
    resetDetails: resetDetails,
    setPatientDetail: setPatientDetail,
    formattedSelectedFiles: formattedSelectedFiles,
    unSelect: unSelect,
    setEditRowId: setEditRowId,
    setIsEditModalOpen: setIsEditModalOpen,
    error: error,
    isEditModalOpen: isEditModalOpen,
    patientDetail: patientDetail
  }));
};
export default FilesList;